import { usePutMutation } from "slices/api";
import { APPLICATION_DETAILS } from "tagTypes";

export const usePutUpdateProjectLocationMutation = () => {
  const [changeLocation, data] = usePutMutation();
  const updateProposedLocation = async (payload, query = {}) =>
    await changeLocation({
      endpoint: "/application/proposed-project-location-update",
      query,
      payload: payload || {},
      toastMessage: "Proposed project location changed successfully",
      tags: [APPLICATION_DETAILS],
    }).unwrap();
  return [updateProposedLocation, data];
};
